import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { appUninstallMutate } from 'queries';
import { reducer } from 'actions/registry/fetch-installed-apps';

export default new AsyncActionHandler({
  name: 'mark_app_removed',
  stateProp: 'markAppRemoved',
  handler: (id) => async (dispatch, getState) => {
    const {
      gallery: {
        deviceInfo: { wireId }
      }
    } = getState();
    const { data: response } = await apollo.mutate({
      mutation: appUninstallMutate,
      variables: {
        id,
        wireId
      }
    });

    return {
      entries: response.uninstallApp
    };
  },
  reduce: reducer
});
